import GlobalStyle from './GlobalStyle'
import MainTheme from './Main'
import ThemeProvider from './ThemeProvider'

const theme = MainTheme
export { GlobalStyle, theme, ThemeProvider }
